'use client';
import { setLogin, setLogout } from '@/redux/features/auth/AuthSlice';
import React, { Component } from 'react';
import { connect } from 'react-redux';

class WelcomePage extends Component {
  render() {
    return (
      <div className='welcome_page'>
        <h2>Welcome to Bangla Namaj Shikkha</h2>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch( setLogout() ),
  }
};
export default connect(mapStateToProps,mapDispatchToProps) (WelcomePage);